/* Werkverzeichnis — Suche, Werkgruppen, Facetten, Sortierung und Rasterrhythmus.
   Verhalten und Beschriftungen aus der Vorlage vom 31.07. (WernerArt.dc.html).

   Die Werke stehen vollständig im Markup; hier wird nur ein- und ausgeblendet,
   sortiert und die Spaltenspanne neu berechnet. Kein Seitenwechsel. */
(function () {
  var FORMATS = ['Alle Formate', 'Hochformat', 'Querformat', 'Quadratisch'];
  var BANDS = ['Jeder Preis', 'bis 300 €', '300 – 600 €', '600 – 1.000 €', 'ab 1.000 €'];
  var SORTS = [
    'Empfehlung',
    'Preis aufsteigend',
    'Preis absteigend',
    'Format, groß zuerst',
    'Jahr, neueste',
    'Jahr, älteste',
    'Titel A – Z'
  ];
  var ALL_MEDIA = 'Alle Techniken';
  var ALL_GROUPS = 'Alle';

  /* Seitenverhältnis proportional zur Spaltenbreite — nur so sind Kacheln einer
     Reihe gleich hoch und die Bildunterschriften fluchten. */
  var ASPECT_FOR_SPAN = { 4: '4 / 3', 3: '1 / 1', 2: '2 / 3' };

  /* Auf schmalen Schirmen zwei Spalten; jede dritte Kachel nimmt die volle
     Breite. Werte aus „WernerArt Mobile.dc.html“. */
  var MOBILE_PATTERN = [1, 1, 2, 1, 1];
  var MOBILE_ASPECT = { 1: '3 / 4', 2: '16 / 10' };

  function isNarrow() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function fmtNumber(n) {
    return Number(n).toLocaleString('de-DE');
  }

  function formatOf(w) {
    if (w.h > w.w) return 'Hochformat';
    if (w.w > w.h) return 'Querformat';
    return 'Quadratisch';
  }

  function bandOf(p) {
    if (p < 300) return BANDS[1];
    if (p < 600) return BANDS[2];
    if (p < 1000) return BANDS[3];
    return BANDS[4];
  }

  /* Spannweite folgt dem Format des Werks (quer = breit, hoch = schmal), damit
     keine leeren Passepartouts entstehen. Reihen werden auf sechs Spalten
     aufgefüllt. */
  function spansFor(items) {
    if (isNarrow()) {
      var mobile = [];
      var i = 0;
      while (mobile.length < items.length) {
        var m = MOBILE_PATTERN[i % MOBILE_PATTERN.length];
        var remaining = items.length - mobile.length;
        if (m === 2 && remaining === 1 && mobile.length % 2 === 1) m = 1;
        mobile.push(m);
        i++;
      }
      return mobile;
    }

    var spans = [];
    var left = 6;
    for (var i = 0; i < items.length; i++) {
      var r = items[i].w / items[i].h;
      var s = r > 1.1 ? 4 : r > 0.92 ? 3 : 2;
      if (s > left) s = left;
      if (left - s === 1) s = left;
      spans.push(s);
      left -= s;
      if (left === 0) left = 6;
    }
    return spans;
  }

  function init(root) {
    if (!root || root.dataset.waBound === '1') return;
    root.dataset.waBound = '1';

    var grid = root.querySelector('[data-wa-gallery-grid]');
    var tiles = [].slice.call(root.querySelectorAll('[data-wa-tile]'));
    if (!grid) return;

    var works = tiles.map(function (el) {
      return {
        el: el,
        title: el.dataset.title || '',
        groups: (el.dataset.groups || '').split('|').filter(Boolean),
        medium: el.dataset.medium || '',
        year: el.dataset.year || '',
        wv: el.dataset.wv || '',
        size: el.dataset.size || '',
        w: Number(el.dataset.w) || 1,
        h: Number(el.dataset.h) || 1,
        price: Number(el.dataset.price) || 0,
        status: el.dataset.status || 'available'
      };
    });

    var pageSize = Number(root.dataset.pageSize) || 24;

    var state = {
      q: '',
      group: ALL_GROUPS,
      format: FORMATS[0],
      band: BANDS[0],
      medium: ALL_MEDIA,
      onlyAvailable: false,
      sort: SORTS[0],
      visible: pageSize
    };

    /* --- Optionslisten aus dem tatsächlichen Bestand ------------------- */
    var groupNames = [];
    var mediaNames = [];
    works.forEach(function (w) {
      w.groups.forEach(function (g) {
        if (groupNames.indexOf(g) === -1) groupNames.push(g);
      });
      if (w.medium && mediaNames.indexOf(w.medium) === -1) mediaNames.push(w.medium);
    });
    groupNames.sort(function (a, b) { return a.localeCompare(b, 'de'); });
    mediaNames.sort(function (a, b) { return a.localeCompare(b, 'de'); });

    var FACETS = {
      format: { key: 'format', options: FORMATS, none: FORMATS[0] },
      band: { key: 'band', options: BANDS, none: BANDS[0] },
      medium: { key: 'medium', options: [ALL_MEDIA].concat(mediaNames), none: ALL_MEDIA },
      sort: { key: 'sort', options: SORTS, none: SORTS[0] }
    };

    /* --- Elemente ------------------------------------------------------ */
    var el = {
      title: root.querySelector('[data-wa-gallery-title]'),
      count: root.querySelector('[data-wa-gallery-count]'),
      search: root.querySelector('[data-wa-gallery-search]'),
      clear: root.querySelector('[data-wa-gallery-clear]'),
      groups: root.querySelector('[data-wa-gallery-groups]'),
      avail: root.querySelector('[data-wa-gallery-avail]'),
      chips: root.querySelector('[data-wa-gallery-chips]'),
      void: root.querySelector('[data-wa-gallery-void]'),
      shown: root.querySelector('[data-wa-gallery-shown]'),
      more: root.querySelector('[data-wa-gallery-more]'),
      next: root.querySelector('[data-wa-gallery-next]'),
      reset: root.querySelector('[data-wa-gallery-reset]'),
      sheet: root.querySelector('[data-wa-sheet]'),
      sheetOpen: root.querySelector('[data-wa-sheet-open]'),
      sheetAvail: root.querySelector('[data-wa-sheet-avail]'),
      sheetAvailValue: root.querySelector('.wa-sheet__avail-value'),
      sheetCount: root.querySelector('[data-wa-sheet-count]')
    };

    var filterLabel = el.sheetOpen ? el.sheetOpen.textContent.trim() : 'Filter';

    var baseTitle = el.title ? el.title.textContent.trim() : '';

    /* --- Werkgruppenzeile --------------------------------------------- */
    if (el.groups) {
      [ALL_GROUPS].concat(groupNames).forEach(function (name) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'wa-gallery__filter';
        b.textContent = name;
        b.addEventListener('click', function () {
          setFacet({ group: name });
        });
        el.groups.appendChild(b);
      });

      // Erst jetzt steht die Breite der Zeile fest — die Laufleiste neu messen.
      document.dispatchEvent(new CustomEvent('wa:rails'));
    }

    /* --- Aufklappmenüs ------------------------------------------------- */
    var panels = [];

    Object.keys(FACETS).forEach(function (key) {
      var wrap = root.querySelector('[data-wa-facet="' + key + '"]');
      if (!wrap) return;

      var trigger = wrap.querySelector('[data-wa-facet-trigger]');
      var panel = wrap.querySelector('[data-wa-facet-panel]');
      var caret = wrap.querySelector('[data-wa-facet-caret]');
      var valueEl = wrap.querySelector('[data-wa-facet-value]');

      FACETS[key].options.forEach(function (name) {
        var opt = document.createElement('button');
        opt.type = 'button';
        opt.className = 'wa-facet__option';
        opt.textContent = name;
        opt.addEventListener('click', function (e) {
          e.stopPropagation();
          var patch = {};
          patch[key] = name;
          setFacet(patch);
          close();
        });
        panel.appendChild(opt);
      });

      function close() {
        panel.hidden = true;
        wrap.removeAttribute('data-open');
        caret.textContent = '+';
      }

      function open() {
        panels.forEach(function (p) { p.close(); });
        panel.hidden = false;
        wrap.setAttribute('data-open', '1');
        caret.textContent = '−';
      }

      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        if (panel.hidden) open(); else close();
      });

      panels.push({
        close: close,
        sync: function () {
          valueEl.textContent = state[key];
          [].slice.call(panel.children).forEach(function (opt) {
            if (opt.textContent === state[key]) opt.setAttribute('data-selected', '1');
            else opt.removeAttribute('data-selected');
          });
        }
      });
    });

    document.addEventListener('click', function () {
      panels.forEach(function (p) { p.close(); });
    });

    /* --- Filterfläche auf schmalen Schirmen --------------------------- */
    var sheetGroups = [];

    ['format', 'band', 'medium'].forEach(function (key) {
      var box = root.querySelector('[data-wa-sheet-facet="' + key + '"]');
      if (!box) return;

      FACETS[key].options.forEach(function (name) {
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'wa-sheet__chip';
        chip.textContent = name;
        chip.addEventListener('click', function () {
          var patch = {};
          patch[key] = name;
          setFacet(patch);
        });
        box.appendChild(chip);
      });

      sheetGroups.push({
        key: key,
        sync: function () {
          [].slice.call(box.children).forEach(function (chip) {
            if (chip.textContent === state[key]) chip.setAttribute('data-active', '1');
            else chip.removeAttribute('data-active');
          });
        }
      });
    });

    function openSheet() {
      if (!el.sheet) return;
      el.sheet.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function closeSheet() {
      if (!el.sheet) return;
      el.sheet.hidden = true;
      document.body.style.overflow = '';
    }

    if (el.sheetOpen) el.sheetOpen.addEventListener('click', openSheet);

    root.querySelectorAll('[data-wa-sheet-close]').forEach(function (b) {
      b.addEventListener('click', closeSheet);
    });

    if (el.sheetAvail) {
      el.sheetAvail.addEventListener('click', function () {
        setFacet({ onlyAvailable: !state.onlyAvailable });
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && el.sheet && !el.sheet.hidden) closeSheet();
    });

    /* --- Filtern, sortieren, zeichnen ---------------------------------- */
    function matches(w) {
      if (state.group !== ALL_GROUPS && w.groups.indexOf(state.group) === -1) return false;
      if (state.format !== FORMATS[0] && formatOf(w) !== state.format) return false;
      if (state.band !== BANDS[0] && bandOf(w.price) !== state.band) return false;
      if (state.medium !== ALL_MEDIA && w.medium !== state.medium) return false;
      if (state.onlyAvailable && w.status !== 'available') return false;

      var q = state.q.trim().toLowerCase();
      if (q) {
        var hay = [w.title, w.groups.join(' '), w.medium, w.year, w.wv, w.size]
          .join(' ')
          .toLowerCase();
        var terms = q.split(/\s+/);
        for (var i = 0; i < terms.length; i++) {
          if (hay.indexOf(terms[i]) === -1) return false;
        }
      }
      return true;
    }

    function sortList(list) {
      var l = list.slice();
      switch (state.sort) {
        case 'Preis aufsteigend': return l.sort(function (a, b) { return a.price - b.price; });
        case 'Preis absteigend': return l.sort(function (a, b) { return b.price - a.price; });
        case 'Format, groß zuerst': return l.sort(function (a, b) { return b.w * b.h - a.w * a.h; });
        case 'Jahr, neueste': return l.sort(function (a, b) { return Number(b.year) - Number(a.year); });
        case 'Jahr, älteste': return l.sort(function (a, b) { return Number(a.year) - Number(b.year); });
        case 'Titel A – Z': return l.sort(function (a, b) { return a.title.localeCompare(b.title, 'de'); });
        default: return l;
      }
    }

    function setFacet(patch) {
      Object.keys(patch).forEach(function (k) { state[k] = patch[k]; });
      if (!('visible' in patch)) state.visible = pageSize;

      // Kurzes Abblenden, während das Raster neu gesetzt wird.
      grid.setAttribute('data-busy', '1');
      window.setTimeout(function () { grid.removeAttribute('data-busy'); }, 220);

      render();
    }

    function chip(label, onRemove) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'wa-chip';
      b.innerHTML = '';
      b.appendChild(document.createTextNode(label + ' '));
      var x = document.createElement('span');
      x.className = 'wa-chip__x';
      x.textContent = '×';
      b.appendChild(x);
      b.addEventListener('click', onRemove);
      return b;
    }

    function reset() {
      if (el.search) el.search.value = '';
      setFacet({
        q: '',
        group: ALL_GROUPS,
        format: FORMATS[0],
        band: BANDS[0],
        medium: ALL_MEDIA,
        onlyAvailable: false,
        sort: SORTS[0]
      });
    }

    function render() {
      var hits = sortList(works.filter(matches));
      var shown = hits.slice(0, state.visible);
      var spans = spansFor(shown);

      // Reihenfolge und Spannweite setzen, alles andere ausblenden.
      // Die Kacheln werden wirklich umgehängt: Die automatische Platzierung im
      // Raster folgt der Dokumentreihenfolge, und nur dann passen Spannweite
      // und Reihenaufteilung zusammen.
      works.forEach(function (w) { w.el.hidden = true; });

      var narrow = isNarrow();
      var aspects = narrow ? MOBILE_ASPECT : ASPECT_FOR_SPAN;

      var frag = document.createDocumentFragment();
      shown.forEach(function (w, i) {
        w.el.hidden = false;
        w.el.style.gridColumn = 'span ' + spans[i];
        w.el.style.setProperty('--wa-gtile-aspect', aspects[spans[i]]);
        frag.appendChild(w.el);
      });
      grid.insertBefore(frag, grid.firstChild);

      if (el.title) el.title.textContent = state.group === ALL_GROUPS ? baseTitle : state.group;

      if (el.count) {
        el.count.textContent =
          fmtNumber(hits.length) + ' ' + (hits.length === 1 ? 'Werk' : 'Werke') +
          ' von ' + fmtNumber(works.length);
      }

      if (el.clear) el.clear.hidden = state.q.trim() === '';

      if (el.groups) {
        [].slice.call(el.groups.children).forEach(function (b) {
          if (b.textContent === state.group) b.setAttribute('data-active', '1');
          else b.removeAttribute('data-active');
        });
      }

      if (el.avail) {
        if (state.onlyAvailable) el.avail.setAttribute('data-active', '1');
        else el.avail.removeAttribute('data-active');
      }

      panels.forEach(function (p) { p.sync(); });

      // Aktive Facetten als abwählbare Marken.
      if (el.chips) {
        el.chips.innerHTML = '';
        var list = [];
        if (state.q.trim()) {
          list.push(['„' + state.q.trim() + '“', function () {
            if (el.search) el.search.value = '';
            setFacet({ q: '' });
          }]);
        }
        if (state.group !== ALL_GROUPS) list.push([state.group, function () { setFacet({ group: ALL_GROUPS }); }]);
        if (state.format !== FORMATS[0]) list.push([state.format, function () { setFacet({ format: FORMATS[0] }); }]);
        if (state.band !== BANDS[0]) list.push([state.band, function () { setFacet({ band: BANDS[0] }); }]);
        if (state.medium !== ALL_MEDIA) list.push([state.medium, function () { setFacet({ medium: ALL_MEDIA }); }]);
        if (state.onlyAvailable) list.push(['Nur verfügbare', function () { setFacet({ onlyAvailable: false }); }]);

        list.forEach(function (c) { el.chips.appendChild(chip(c[0], c[1])); });

        if (list.length) {
          var all = document.createElement('button');
          all.type = 'button';
          all.className = 'wa-chips__reset';
          all.textContent = 'Alles zurücksetzen';
          all.addEventListener('click', reset);
          el.chips.appendChild(all);
        }
        el.chips.hidden = list.length === 0;

        // Der Knopf zur Filterfläche zeigt, wie viele Facetten gesetzt sind.
        if (el.sheetOpen) {
          el.sheetOpen.textContent = list.length
            ? filterLabel + ' (' + list.length + ')'
            : filterLabel;
        }
      }

      sheetGroups.forEach(function (g) { g.sync(); });

      if (el.sheetAvail) {
        if (state.onlyAvailable) el.sheetAvail.setAttribute('data-active', '1');
        else el.sheetAvail.removeAttribute('data-active');
      }

      if (el.sheetCount) {
        el.sheetCount.textContent = fmtNumber(shown.length) + ' von ' + fmtNumber(hits.length) + ' angezeigt';
      }

      if (el.void) el.void.hidden = hits.length > 0;

      if (el.shown) {
        el.shown.textContent = hits.length
          ? fmtNumber(shown.length) + ' von ' + fmtNumber(hits.length) + ' angezeigt'
          : '';
      }

      if (el.more) {
        var moreHere = hits.length > shown.length;
        el.more.hidden = !moreHere && !(el.next && hits.length === works.length);
        el.more.dataset.mode = moreHere ? 'local' : 'page';
      }
    }

    /* --- Ereignisse ---------------------------------------------------- */
    if (el.search) {
      var timer = null;
      el.search.addEventListener('input', function () {
        window.clearTimeout(timer);
        timer = window.setTimeout(function () {
          setFacet({ q: el.search.value });
        }, 140);
      });
    }

    if (el.clear) {
      el.clear.addEventListener('click', function () {
        el.search.value = '';
        setFacet({ q: '' });
      });
    }

    if (el.avail) {
      el.avail.addEventListener('click', function () {
        setFacet({ onlyAvailable: !state.onlyAvailable });
      });
    }

    if (el.reset) el.reset.addEventListener('click', reset);

    // Beim Wechsel zwischen schmal und breit ändert sich der Rasterrhythmus.
    window.matchMedia('(max-width: 749px)').addEventListener('change', render);

    if (el.more) {
      el.more.addEventListener('click', function () {
        if (el.more.dataset.mode === 'page' && el.next) {
          window.location.href = el.next.getAttribute('href');
          return;
        }
        setFacet({ visible: state.visible + pageSize });
      });
    }

    render();
  }

  document.querySelectorAll('[data-wa-gallery]').forEach(init);

  document.addEventListener('shopify:section:load', function (event) {
    (event.target || document).querySelectorAll('[data-wa-gallery]').forEach(init);
  });
})();
